import React from 'react';
import { Box, Typography } from '@mui/material';
import ContactSection from '../shared/ContactSection';
import { LinkButton } from 'framework/ui/ui-builder';
import { useOneStopRequestsUrl } from 'domain/shared/oneStop';

const DavinciSupportSection: React.FC = () => {
  const { getSingleEntityUrl: getSingleOneStopEntityUrl } = useOneStopRequestsUrl();

  const description = (
    <Box>
      {[
        'Issues while using Syberry internal systems',
        'Business-process interruptions or misconfigurations',
        'Bug reports or improvement ideas for any Davinci product',
      ].map(text => (
        <Box key={text} sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
          <Box
            sx={{
              width: 6,
              height: 6,
              borderRadius: '50%',
              aspectRatio: 1,
              bgcolor: 'success.main',
              mr: 1.5,
            }}
          />
          <Typography variant="body2">{text}</Typography>
        </Box>
      ))}
    </Box>
  );

  const content = (
    <LinkButton url={getSingleOneStopEntityUrl('SUP01')} variant="outlined" size="small" color="primary">
      Create support request
    </LinkButton>
  );

  return (
    <ContactSection title="Davinci Support" subtitle="Issues Davinci support can help with" description={description}>
      {content}
    </ContactSection>
  );
};

export default DavinciSupportSection;
